<template>
  <div class="preview-campaign">
    <div class="line-black"/>
    <div class="div-social">
      <div class="logo">
        <img src="@/assets/logo.png">
      </div>
      <div class="social">
        <a
          href="https://www.facebook.com/AGCOcorp"
          target="_blank">
          <img src="@/assets/facebook-square.svg">
        </a>
        <a
          href="https://twitter.com/agcocorp"
          target="_blank">
          <img
            class="twitter"
            src="@/assets/twitter.svg">
        </a>
        <a
          href="http://crm.netnet.mx/"
          target="_blank">
          <img
            src="@/assets/globe.png"
            style="margin-left: 9px;">
        </a>
      </div>
    </div>
    <div class="div-image">
      <img :src="image">
    </div>
    <div class="div-content">
      <h1>{{ title }}</h1>
      <div
        style="margin-top: 20px"
        v-html="content"/>
    </div>
  </div>
</template>

<script>
/**
*
* PreviewCampaign Component
*
* @author efrenmartinez
* @copyright 2019, Marciano Studio S.C.
*/
export default {
  name: 'PreviewCampaign',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-campaign {
  .line-black{
    width: 100%;
    height: 20px;
    background-color: #000;
  }
  .div-social{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100px;
    .logo{
      img{
        width: 140px;
        height: 80px;
      }
    }
    .social{
      a>img{
        width: 27px;
        margin-left: 15px;
      }
    }
  }
  .div-image{
    img{
      width: 100%;
    }
    border-top: 2px solid #F1F1F1;
    border-bottom: 2px solid #F1F1F1;
  }
  .div-content{
    padding: 40px 40px 30px 40px;
    h1{
      color: #707070;
      @include font-lato(20px, bold);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/_shared/preview-campaign.vue